const theme = {
    dark: {
        background: '#0f0f0f',
        gray: 'rgb(39, 39, 39)',
        border: 'hsl(0, 0%, 18.82%)',
        textMain: '#f1f1f1',
        textSec: '#aaa',
        activeBackground: '#f1f1f1',
        activeText: '#0f0f0f'
    },
    light: {
        background: 'white',
        gray: '#e1e1e1',
        border: '#ccc',
        textMain: '#0f0f0f',
        textSec: '#737373',
        activeBackground: '#0f0f0f',
        activeText: '#f1f1f1'
    }
}

export const updateStyleToTheme = (type) => {
    document.documentElement.style.setProperty('--background', theme[type].background)
    document.documentElement.style.setProperty('--gray', theme[type].gray)
    document.documentElement.style.setProperty('--border', theme[type].border)
    document.documentElement.style.setProperty('--text-primary', theme[type].textMain)
    document.documentElement.style.setProperty('--text-secondary', theme[type].textSec)
    document.documentElement.style.setProperty('--active-background', theme[type].activeBackground)
    document.documentElement.style.setProperty('--active-text', theme[type].activeText)
}
